import { IOrder } from '../models/Orders/IOrder';
import { IOrdersContainer } from '../models/Orders/IOrdersContainer';

function orderServiceMock() {
  function getOrdersPaged(id: string, pageSize: number, pageNumber: number): any {
    var ordersMock: IOrder[] = [
      {
        orderDate: 'August 10, 2021',
        orderNumber: 'SO1318211',
        totalAmount: 100,
        orderLines: [
          {
            description: 'SHRM Annual Conference & Expo 2021 Virtual Registration',
            orderDate: 'August 06, 2021',
            orderNumber: 'SO1318211',
            orderStatus: 'Billed',
            relatedTracking: '',
            totalAmount: 100,
            tracking: 'SO1318211-1',
          },
        ],
      },
      {
        orderDate: 'August 06, 2021',
        orderNumber: 'SO1315200',
        totalAmount: 120,
        orderLines: [
          {
            description: 'SHRM Talent Conference & Expo 2021 Virtual Conference Registration',
            orderDate: 'August 06, 2021',
            orderNumber: 'SO1315200',
            orderStatus: 'Billed',
            relatedTracking: '',
            totalAmount: 120,
            tracking: 'SO1315200-1',
          },
        ],
      },
      {
        orderDate: 'September 21, 2021',
        orderNumber: 'SO1336926-2',
        totalAmount: 219,
        orderLines: [
          {
            description: 'SHRM HR Magazine',
            orderDate: 'September 21, 2021',
            orderNumber: 'SO1336926-2',
            orderStatus: 'Billed',
            relatedTracking: '',
            totalAmount: 219,
            tracking: 'SO1336926-2-1',
          },
        ],
      },
      {
        orderDate: 'September 21, 2021',
        orderNumber: 'SO1336926-1',
        totalAmount: 219,
        orderLines: [
          {
            description: 'Professional Membership',
            orderDate: 'September 21, 2021',
            orderNumber: 'SO1336926-1',
            orderStatus: 'Billed',
            relatedTracking: '',
            totalAmount: 219,
            tracking: 'SO1336926-1-1',
          },
        ],
      },
      {
        orderDate: 'September 29, 2022',
        orderNumber: 'SO1336926-11',
        totalAmount: 219,
        orderLines: [
          {
            description: 'Professional Membership',
            orderDate: 'September 219, 2022',
            orderNumber: 'SO1336926-11',
            orderStatus: 'Billed',
            relatedTracking: '',
            totalAmount: 219,
            tracking: 'SO1336926-1-1',
          },
        ],
      },
    ];

    const totalCount = ordersMock.length;
    let totalPages = 0;

    if (pageSize < 1) {
      pageSize = 10;
    }

    if (pageNumber < 1) {
      pageNumber = 1;
    }

    if (totalCount > 0) {
      totalPages = Math.ceil(totalCount / pageSize);
      const indexOfLastItem = pageNumber * pageSize;
      const indexOfFirstItem = indexOfLastItem - pageSize;

      ordersMock = ordersMock.slice(indexOfFirstItem, indexOfLastItem);
    }

    const orderContainer: IOrdersContainer = {
      orders: ordersMock,
      purchaseCreditUrl: 'https://qa-nsstore.shrm.org/shrm-compensation-data-report-credit',
      reportCreditUrl:
        'https://qa-sso.shrm.org/IDBUS/SHRM-QA/VP-IDP-PROXY/SAML2/SSO/IDP_INITIATE?atricore_sp_alias=SalaryComPurchase',
      salaryCreditBalance: 0,
      totalCount: totalCount,
      totalPages: totalPages,
    };

    return new Promise((resolve, reject) => {
      resolve({
        data: orderContainer,
      });
      throw new Error('Mock exception!');
    });
  }

  function printOrders(id: string, orderNumber: string) {
    return `/api/orderdonation/print?ssouuid=${id}&orderNumber=${orderNumber}`;
  }

  return {
    getOrdersPaged,
    printOrders,
  };
}

export default orderServiceMock;
